<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="车队资料" name="DriverTeamEdit">
      <DriverTeamEdit
        v-if="isDriverTeamEditShow"
        ref="DriverTeamEditRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="车队实际承运人" name="TeamDirver">
      <TeamDirver
        v-if="isTeamDirverShow"
        ref="TeamDirverRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="车队车辆" name="TeamVehicle">
      <TeamVehicle
        v-if="isTeamVehicleShow"
        ref="TeamVehicleRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="常跑线路" name="CommonRouteInfo">
      <CommonRouteInfo
        v-if="isCommonRouteInfoShow"
        ref="CommonRouteInfoRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="邀请实际承运人" name="InviteTheDriver">
      <InviteTheDriver
        v-if="isInviteTheDriverShow"
        ref="InviteTheDriverRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="邀请记录" name="InviteRecord">
      <InviteRecord
        v-if="isInviteRecordShow"
        ref="InviteRecordRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import DriverTeamEdit from "./components/driverTeamEdit.vue";
import TeamDirver from "./components/teamDirver/teamDirverList.vue";
import TeamVehicle from "./components/teamVehicle/teamVehicleList.vue";
import CommonRouteInfo from "./components/commonRouteInfo/commonRouteInfoList.vue";
import InviteTheDriver from "./components/inviteDriver/inviteTheDriver.vue";
import InviteRecord from "./components/inviteDriver/inviteRecord.vue";
import { getListDict } from "@/api/commonApi";
import { getBindList } from "@/api/driver";
export default {
  name: "InfoDriverTeamForm",
  components: {
    DriverTeamEdit,
    TeamDirver,
    TeamVehicle,
    CommonRouteInfo,
    InviteTheDriver,
    InviteRecord
  },
  data() {
    return {
      parentData: {
        isDetail: true,
        areaOptions: this.$store.state.components.areaOptions,
        vehicleBindList: [],
        vehicleTypeAllowList: [],
        vehicleClassificationList: [],
        vehicleLengthList: [],
        vehicleWidthList: [],
        vehicleHighList: [],
        vehicleTonnageList: [],
        locationSourceList: [],
        vehicleEnergyTypeList: [],
        vehicleLicenseColorList: [],
        roadPermit: {}
      },
      tabPaneVal: "DriverTeamEdit",
      isDriverTeamEditShow: true,
      isTeamDirverShow: false,
      isTeamVehicleShow: false,
      isCommonRouteInfoShow: false,
      isInviteTheDriverShow: false,
      isInviteRecordShow: false
    };
  },
  created() {
    var partyCode = this.$route.query.partyCode;
    getBindList({ pageSize: 1000000, teamCode: partyCode, isFreeze: 0 }).then(
      response => {
        this.parentData.vehicleBindList = response.data.records;
      }
    );
    // 获取数据字典： 准驾车型，车型，车长，车宽，车高，吨位，定位来源，能源类型，颜色
    getListDict({
      types:
        "vehicleTypeAllow,vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor"
    }).then(response => {
      this.parentData.vehicleTypeAllowList = response.data.filter(
        item => item.type === "vehicleTypeAllow"
      )[0]["dictList"];
      this.parentData.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.parentData.vehicleLengthList = response.data.filter(
        item => item.type === "vehicleLength"
      )[0]["dictList"];
      this.parentData.vehicleWidthList = response.data.filter(
        item => item.type === "vehicleWidth"
      )[0]["dictList"];
      this.parentData.vehicleHighList = response.data.filter(
        item => item.type === "vehicleHigh"
      )[0]["dictList"];
      this.parentData.vehicleTonnageList = response.data.filter(
        item => item.type === "vehicleTonnage"
      )[0]["dictList"];
      this.parentData.locationSourceList = response.data.filter(
        item => item.type === "locationSource"
      )[0]["dictList"];
      this.parentData.vehicleEnergyTypeList = response.data.filter(
        item => item.type === "vehicleEnergyType"
      )[0]["dictList"];
      this.parentData.vehicleLicenseColorList = response.data.filter(
        item => item.type === "vehicleLicenseColor"
      )[0]["dictList"];
    });
  },
  methods: {
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
      });
      // 重新获取车辆
      var partyCode = this.$route.query.partyCode
        ? this.$route.query.partyCode
        : "";
      if (tab.name === "TeamDirver") {
        getBindList({
          pageSize: 1000000,
          teamCode: partyCode,
          isFreeze: 0
        }).then(response => {
          this.parentData.vehicleBindList = response.data.records;
        });
      }
    }
  }
};
</script>
